module.exports = "/_next/static/images/BuildHighPerformance-1@2x-b796857d0144dd45f0ea009a7b56d982.png";